export default class SentEmailPopup {
    constructor($ionicPopup, $filter, $rootScope) {
        this.$ionicPopup = $ionicPopup;
        this.$translate = $filter('translate');
        this.$rootScope = $rootScope;
    }

    show(username, sentEmail) {
        const confirmPopup = this.$ionicPopup.confirm({
            title: this.$translate('EXPORT_TO_EMAIL'),
            template: this.$rootScope.isIosApp
                ? `<span>${this.$translate(
                      'EXPORT_TO_EMAIL_CONFIRM_IOS_PART_1',
                      { username }
                  )}</span>
                  <a ng-click="$root.openIOSTerm($event)" data-tap-disabled='true'>${this.$translate(
                      'TERMS_AND_CONDITIONS_SMALL_CASE'
                  )}</a>
                  <span>${this.$translate(
                      'EXPORT_TO_EMAIL_CONFIRM_IOS_PART_2'
                  )}</span>`
                : this.$translate('EXPORT_TO_EMAIL_CONFIRM', { username }),
        });

        confirmPopup.then(
            function (res) {
                if (res) {
                    sentEmail();
                }
            }.bind(this)
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/services/sentEmailPopup.js
 **/